import { render } from "./ManagerRole.vue?vue&type=template&id=0c43461a"
import script from "./ManagerRole.vue?vue&type=script&lang=js"
export * from "./ManagerRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__